import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/htx/screening-procedures/colonoscopy";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	colonoscopy: {
		id: "form.colonoscopy",
		defaultMessage: "Colonoscopia"
	},
	result: {
		id: "form.colonoscopy.result",
		defaultMessage: "Eltérés"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.result }] }]
};

export const node: LeafNode = {
	id: "colonoscopy",
	value: {
		title: messages.colonoscopy,
		validator,
		fieldset
	}
};
